function initializeArrayFunctions() {

  // USAGE EXAMPLE

  // -----------------------------------------------------------------------------
  // this.$constants.LAYER_GROUPS.findRecursive(x=>x.name=="Accessories 1", "subGroups");
  // -----------------------------------------------------------------------------

  Array.prototype.findRecursive = function (predicate, childrenPropertyName) {
    if (!childrenPropertyName) {
      throw "findRecursive requires parameter `childrenPropertyName`";
    }
    let array = [];
    array = this;
    let initialFind = array.find(predicate);
    let elementsWithChildren = array.filter(x => x[childrenPropertyName]);
    if (initialFind) {
      return initialFind;
    } else if (elementsWithChildren.length) {
      let childElements = [];
      elementsWithChildren.forEach(x => {
        childElements.push(...x[childrenPropertyName]);
      });
      return childElements.findRecursive(predicate, childrenPropertyName);
    } else {
      return undefined;
    }
  }

  Array.prototype.filterRecursive = function (predicate, childProperty) {
    let filterResults = [];
    let filterAndPushResults = (arrayToFilter) => {
      let elementsWithChildren = arrayToFilter.filter(x => x[childProperty]);
      let filtered = arrayToFilter.filter(predicate);
      filterResults.push(...filtered);
      if (elementsWithChildren.length) {
        let childElements = [];
        elementsWithChildren.forEach(x => {
          childElements.push(...x[childProperty]);
        });
        filterAndPushResults(childElements);
      }
    };
    filterAndPushResults(this);
    return filterResults;
  }

  // USAGE EXAMPLE
  // -----------------------------------------------------------------------------
  // arrA.compareArryOfObjects(arrB);
  // -----------------------------------------------------------------------------

  Array.prototype.compareArryOfObjects = function (arrB, bool = false) {
    const comparer = (a, b) => {
      return a.filter(function(obj) {
          return !b.some(function(obj2) {
              return obj.value == obj2.value;
          });
      });
    }

    const uniqueResultOne = comparer(this, arrB)
    const uniqueResultTwo = comparer(arrB, this)
    const result = uniqueResultOne.concat(uniqueResultTwo)

    return bool ? result.length === 0 : result
  }
}

export default initializeArrayFunctions;



// WEBPACK FOOTER //
// ./src/utils/ArrayFunctions.js